/**
 * Minimum bookable stay length for an LE hotel offer (package options).
 * Matches how hotel offer tiles caption duration ("5 nights from").
 */
export function getHotelOfferMinNights(offer: App.AnyOffer | undefined): number | undefined {
  if (!offer) return undefined

  if ('minDuration' in offer) {
    const minDuration = offer.minDuration
    if (typeof minDuration === 'number' && minDuration > 0) {
      return minDuration
    }
  }

  if ('lowestPricePackage' in offer) {
    const lowestPricePackage = offer.lowestPricePackage
    const duration = lowestPricePackage && 'duration' in lowestPricePackage
      ? lowestPricePackage.duration
      : undefined
    if (typeof duration === 'number' && duration > 0) {
      return duration
    }
  }

  if ('packages' in offer && Array.isArray(offer.packages) && offer.packages.length > 0) {
    let minPackageDuration: number | undefined
    for (const pkg of offer.packages) {
      if (!('duration' in pkg)) continue
      const duration = pkg.duration
      if (typeof duration === 'number' && duration > 0) {
        minPackageDuration = minPackageDuration === undefined
          ? duration
          : Math.min(minPackageDuration, duration)
      }
    }
    if (minPackageDuration !== undefined) {
      return minPackageDuration
    }
  }

  return undefined
}

/**
 * Prefer an existing itinerary stay or date-filter nights, but never below the
 * offer's minimum length of stay.
 */
export function resolveHotelStayNights({
  existingNights,
  filterNights,
  minNights,
}: {
  existingNights?: number
  filterNights?: number
  minNights?: number
}): number {
  const floor = minNights && minNights > 0 ? minNights : 1
  const preferred = existingNights ?? filterNights ?? floor
  return Math.max(preferred, floor)
}
